<div class="sidebar-wrapper sidebar-solser-wrapper">
  <ul class="nav sidebar-primary-nav">
    <li routerLinkActive="active" class="nav-item">
      <a (click)="ocultarMenu()" [routerLink]="['/dashboard']" class="nav-link sidebar-link">
        <i class="material-icons">dashboard</i>
        <p>Inicio</p>
      </a>
    </li>

    <ng-container *ngFor="let menuitem of menuItems">
      <li routerLinkActive="active" class="nav-item" *ngIf="deArriba(menuitem)">
        <ng-container *ngTemplateOutlet="entrada; context: { $implicit: menuitem }"></ng-container>
      </li>
    </ng-container>
  </ul>

  <!-- Configuracion y Consola van abajo, separadas de los grupos: se usan
       poco y no compiten con el trabajo del dia. -->
  <ul class="nav sidebar-primary-nav sidebar-fijos" *ngIf="fijos.length > 0">
    <ng-container *ngFor="let menuitem of fijos">
      <li routerLinkActive="active" class="nav-item">
        <ng-container *ngTemplateOutlet="entrada; context: { $implicit: menuitem }"></ng-container>
      </li>
    </ng-container>
  </ul>

  <ng-template #entrada let-menuitem>
    <a (click)="ocultarMenu()" [routerLink]="linkDe(menuitem)" *ngIf="menuitem.tipo === 'link'"
      class="nav-link sidebar-link">
      <i class="material-icons">{{ menuitem.icono }}</i>
      <p>{{ menuitem.nombre }}</p>
    </a>

    <a href="#{{ menuitem.collapse }}" *ngIf="menuitem.tipo === 'sub'"
      (click)="expandOrCollapseMenu(menuitem.collapse, $event)"
      [attr.aria-expanded]="isMenuExpanded(menuitem.collapse)"
      class="nav-link sidebar-link sidebar-link-toggle">
      <i class="material-icons">{{ menuitem.icono }}</i>
      <p>{{ menuitem.nombre }}<b class="caret"></b></p>
    </a>
    <!--Display the submenu items-->

    <div id="{{ menuitem.collapse }}" class="collapse" [class.show]="isMenuExpanded(menuitem.collapse)" *ngIf="menuitem.tipo === 'sub'">
      <ul class="nav">
        <li routerLinkActive="active" *ngFor="let childitem of hijosEnPanel(menuitem)" class="nav-item">
          <a (click)="ocultarMenu()" [routerLink]="linkDe(childitem, menuitem)"
            class="nav-link sidebar-child-link">
            <i class="material-icons">{{ childitem.icono }}</i>

            <span class="sidebar-normal">{{ childitem.nombre }}</span>
          </a>
          <!-- Las pantallas que se abren desde esta hoja y no tienen la suya
               (las matrices, desde Gestión de Riesgos): enlaces ocultos para
               que routerLinkActive marque la hoja también ahí. No se ven, no
               reciben foco y el lector de pantalla no los anuncia. -->
          <a *ngFor="let ruta of abreTambien(childitem)" [routerLink]="ruta"
            hidden tabindex="-1" aria-hidden="true" [attr.aria-label]="childitem.nombre"></a>
        </li>
      </ul>
    </div>
  </ng-template>

  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright pull-right">
        &copy;
        {{ fecha | date : "yyyy" }},
        <a href="https://www.solsersistem.net" target="_blank">Centro Operativo Solser v2.0</a>
      </div>
    </div>
  </footer>
</div>
